
import axios from 'axios'

//API_URL needs to be whatver the server route is
const API_URL = 'https://elana-api.herokuapp.com/api/practitionerUsers/'

// Register User
const register = async (userData) => {
  const response = await axios.post(API_URL, userData)

  if (response.data) {
    console.log(response.data)
  }

  return response.data
}

// Login User
const login = async (userData) => {
  const response = await axios.post(API_URL + 'practitionerLogin', userData)

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
    const token = JSON.stringify(response.data.token).slice(1, -1)
    localStorage.setItem('token', token)
  }

  return response.data
}

// Logout User
const logout = () => {
  localStorage.removeItem('user')
}

// Get All Practitioners
const getPractitionerUsers = async () => {
  const response = await axios.get(API_URL + 'users')
  return response.data
}

// Practitioner updating their information
const updateUser = async (userData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  const response = await axios.put(API_URL, userData, config)
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
    const token = JSON.stringify(response.data.token).slice(1, -1)
    localStorage.setItem('token', token)
  }
  return response.data

}

// Admin updating verified property
const updateUserAdmin = async (userData, token, userId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  const response = await axios.put(`${API_URL}admin/${userId}`, userData, config)
  return response.data
}

// here start the AuthService for send the email reset password to the emails.
const resetPasswordEmail = async (userData) => {
  const response = await axios.post(API_URL + 'forgot-password', userData)
  return response.data
}

const createNewPassword = async (data, id, token) => {
  const response = await axios.post(`${API_URL}reset-password/${id}/${token}`, data)
  return response.data
}

const deleteUserAndProfile = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  const response = await axios.delete(`${API_URL}delete/${id}`, config)
  return response.data
}

const authService = {
  register,
  logout,
  login,
  getPractitionerUsers,
  updateUser,
  updateUserAdmin,
  resetPasswordEmail,
  createNewPassword,
  deleteUserAndProfile
}

export default authService